import { httpGet } from "@/services/api.service";
import { ENDPOINT_SEMANTIC } from "@/common/constants/api";

export { _getSemanticWords as getSemanticWords };

const _getSemanticWords = async (params) => {
  try {
    const word = encodeURIComponent(params.word);
    const URL = `${ENDPOINT_SEMANTIC}/${word}`;
    const RESULT = await httpGet({ url: URL });

    if (RESULT) {
      const PARSED_RESULTS = JSON.parse(RESULT);
      return PARSED_RESULTS.data;
    }
    return null;
  } catch (error) {
    console.error("Error occurred while getting semantic words", error);
    return null;
  }
};
